import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Slider from '@material-ui/lab/Slider'
import Typography from '@material-ui/core/Typography'
import {ContextConsumer} from '../Context'

const styles = {
  card: {
    width: 400,
    position: 'fixed',
    top: 70,
    right: 5,
    padding: 20,
  },
  title: {
    marginBottom: 16,
    fontSize: '1.2rem',
  },
  cardContent: {
    paddingTop: 0,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  cardItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textField: {
    width: '100%',
  },
  error: {
    color: 'red',
  },
}

const FrameSizer = ({classes}) => {
  return (
    <ContextConsumer>
      {context => {
        const {innerHeight, innerWidth} = window
        return (
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography className={classes.title} color="textSecondary">
                iFrame sizer
              </Typography>
              <div className={classes.cardItem}>
                Width:{' '}
                <Slider
                  value={context.frameWidth}
                  min={500}
                  max={3000}
                  step={10}
                  onChange={context.handleChangeW}
                />
                <Typography variant="caption" color="textSecondary">
                  {context.frameWidth}px
                </Typography>
              </div>
              <div className={classes.cardItem}>
                Height:{' '}
                <Slider
                  value={context.frameHeight}
                  min={300}
                  max={2000}
                  step={10}
                  onChange={context.handleChangeH}
                />
                <Typography variant="caption" color="textSecondary">
                  {context.frameHeight}px
                </Typography>
              </div>
            </CardContent>
            {innerHeight - 80 < context.frameHeight && (
              <Typography
                variant="title"
                className={classes.error}
                align="center">
                The iFrame is taller than your screen
              </Typography>
            )}
            {innerWidth < context.frameWidth && (
              <Typography
                variant="title"
                className={classes.error}
                align="center">
                The iFrame is wider than your screen
              </Typography>
            )}
          </Card>
        )
      }}
    </ContextConsumer>
  )
}

FrameSizer.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(FrameSizer)



// WEBPACK FOOTER //
// ./src/components/FrameSizer.js